// Vendor libraries
import { createAction, props } from '@ngrx/store';
// Set the search term used to filter folderable items by name.
export const setName = createAction('[Folders] Set Name', props());
